import React, { useContext, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useCart } from "react-use-cart";
import { notifySuccess, notifyError } from "../utils/toast";
import CustomerServices from "../services/CutomerServices";
import useUtilsFunction from "../hooks/useUtilsFunction";
import { AppContext } from "../context/AppContext";
import StripeModal from "../components/modal/StripeModal";
import { saveStoreOrderId, saveCustomer } from "../redux/reducers/appSlice";
import storesData from "../utils/stores.json";
import { SiVoidlinux } from "react-icons/si";
import OrderServices from "../services/OrderServices";
import PaymentOptionModal from "../components/modal/PaymentOptionsModal";
function Footer() {
    const dispatch = useDispatch();
    const { emptyCart, items, cartTotal } = useCart();
    const { customer } = useSelector((state) => state.app);
    const { adminDetail } = useSelector((state) => state.auth);
    const { catchError } = useUtilsFunction();
    const { setCustomerModal, setBillingAddress, stripeModal, setSreipeModal } = useContext(AppContext);

    const [loading, setLoading] = useState(false);
    const [orderId, setOrderId] = useState("");
    const [cartItems, setCartItems] = useState([]);
    const [customerId, setCustomerId] = useState("");
    const [checkoutUrl, setCheckoutUrl] = useState("");
    const [showOptionModal, setShowOptionModal] = useState(false);
    const [showUrlModal, setShowUrlModal] = useState(false);
    const [copied, setCopied] = useState(false);
    // const onClickCheckout = () => {
    //     if (items.length === 0) return;
    //     setShowOptionModal(true);
    // };
        const onClickCheckout = () => {
        if (items.length === 0) return;
        let guestCustomer = {
                "_id": "8cfa71a2-bce0-4b29-a240-0647e7b40060",
                "first_name": "Guest",
                "last_name": ".",
                "phone": "9999999999",
                "raw": {
                    "_id": "8cfa71a2-bce0-4b29-a240-0647e7b40060",
                    "first_name": "Guest",
                    "last_name": ".",
                    "username": "Guest",
                    "phone": "9999999999",
                    "email": "guest@pos.com",
                    "stripeCustomerId": "cus_SH2DRja3auMKmA",
                    "createdAt": "2025-05-08T13:05:28.390Z",
                    "updatedAt": "2025-05-08T13:05:28.390Z",
                    "__v": 0
                }
            }
        
            // const hasRecurringPrice = prod.prices?.some((p) => p.recurring) ?? false;
            // console.log("hasRecurringPrice", customer, hasRecurringPrice);
             if (!customer?._id) {
              dispatch(saveCustomer(guestCustomer.raw || guestCustomer));
              // setCustomerModal(true);
                setShowOptionModal(true);

              // setBillingAddress(true);
            }
                setShowOptionModal(true);
        }
    const createOrder = async () => {
        // Load store info & cart
          
        const storeKey = localStorage.getItem("react-use-cart");
        const selectedStore = storesData.find((s) => s.id === storeKey);
        const savedCart = localStorage.getItem("react-use-cart");
        const parsed = savedCart ? JSON.parse(savedCart) : { items: [], cartTotal: 0 };
        const rawItems = parsed.items;

        // Determine need for shipping and login state
        const needsShipping = rawItems.some((i) => i.shipping_required);
        const isLoggedIn = Boolean(customer && customer._id);
        if (needsShipping && !isLoggedIn) {
            setCustomerModal(true);
            setBillingAddress(true);
            return;
        }
        setShowOptionModal(false);
        setLoading(true);
        try {
            // Ensure a customer record exists (guest or logged-in)
            let current = customer;
            if (!isLoggedIn) {
                // Attempt to create a guest customer
                const guestPayload = {
                    email: "guest@pos.com",
                    first_name: "Guest",
                    last_name: ".",
                    username: "Guest",
                    phone: "9999999999",
                };
                try {
                    const resp = await CustomerServices.addCustomerApi(guestPayload);
                    current = resp;
                } catch (err) {
                    const errMsg = catchError(err);
                    if (err.response?.data?.code === "EMAIL_EXISTS") {
                        // Email already exists: fetch existing customer
                        const existing = {
                            email: "guest@pos.com",
                            first_name: "Guest",
                            last_name: ".",
                            username: "Guest",
                            phone: "9999999999",
                            stripeCustomerId: "cus_SH2DRja3auMKmA",
                        };
                        current = existing;
                    } else {
                        throw err;
                    }
                }
                dispatch(saveCustomer(current));
            }

            // Build billing object
            const billing = {
                first_name: current.billing?.first_name || current.first_name || "Guest",
                ...current.billing,
            };

            // Prepare line items
            console.log("🚀 ~ createOrder ~ rawItems:", rawItems)
            const lineItems = rawItems.map((i) => ({ product_id: i.id, quantity: i.quantity, price_id: i.price_id }));
            setCartItems(lineItems);

            // Assemble order payload
            const payload = {
                payment_method: "delimpterminal",
                payment_method_title: "Terminal",
                set_paid: false,
                customer_id: current.stripeCustomerId,
                // customer_id: current._id,
                billing,
                shipping: current.shipping || {},
                line_items: lineItems,
                meta_data: [
                    { key: "user_id", value: adminDetail.id },
                    { key: "user_name", value: adminDetail.username },
                    { key: "store_name", value: selectedStore?.label },
                    { key: "store_id", value: selectedStore?.id },
                    { key: "cart", value: JSON.stringify(lineItems) },
                ],
            };

            // Place the order
            const orderResp = await OrderServices.createOrderApi(payload);
            const newOrderId = orderResp._id;

            setOrderId(newOrderId);
            dispatch(saveStoreOrderId(newOrderId));
            setCustomerId(current.stripeCustomerId || "");
            notifySuccess("Order created successfully!");
            setSreipeModal(true);
        } catch (err) {
            notifyError(catchError(err));
        } finally {
            setLoading(false);
        }
    };
    // New checkout URL logic
    const handleUrlOrder = async () => {
        setShowOptionModal(false);
        setLoading(true);
        try {
            // Ensure customer presence (guest or logged-in)
            let current = customer;
            if (!customer?._id) {
                const guest = {
                    email: 'guest@pos.com',
                    first_name: 'Guest',
                    last_name: '.',
                    username: 'Guest',
                    phone: '9999999999',
                };
                try {
                    const resp = await CustomerServices.addCustomerApi(guest);
                    current = resp.data;
                } catch (err) {
                    current = { ...guest, stripeCustomerId: err.response?.data?.existingStripeId };
                }
                dispatch(saveCustomer(current));
            }

            const line_items = items.map(i => ({
                price_id: i.price_id,
                quantity: i.quantity,
                recurring: i.recurring,
            }));

            const resp = await OrderServices.createCheckoutUrlApi({
                customerId: current.stripeCustomerId || current._id,
                items: line_items,
            });
            console.log("🚀 ~ handleUrlOrder ~ resp:", resp)

            setCheckoutUrl(resp.checkout_url);
            setShowUrlModal(true);
            notifySuccess('Checkout URL generated!');
        } catch (err) {
            notifyError(catchError(err));
        } finally {
            setLoading(false);
            
        }
    };

    const handleVoidProduct = () => {
        dispatch(saveCustomer(null));
        emptyCart();
    };

    return (
        <>
            <footer className="bg-[#9bc1e9] text-white fixed bottom-0 w-full z-40">
                <div className="px-[10px] py-[15px] lg:px-5 lg:pl-3">
                    <div className="flex items-center justify-between">
                        <div className="flex items-center">
                            <span className="text-xl text-[#4f598c] font-semibold">Total ${cartTotal?.toFixed(2)}</span>
                            <button
                                onClick={onClickCheckout}
                                disabled={loading}
                                className="ml-4 bg-[#4f598c] px-4 py-2 rounded hover:bg-gray-700 transition"
                            >
                                {loading ? "Processing…" : "Checkout"}
                            </button>
                        </div>
                        <button
                            onClick={handleVoidProduct}
                            className="bg-red-500 px-6 py-2 rounded hover:bg-red-300 transition flex items-center"
                        >
                            <SiVoidlinux className="mr-2" /> Void
                        </button>
                    </div>
                </div>
                {/* Option Modal */}
                {/* {showOptionModal && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                        <div className="relative bg-white p-6 rounded-lg">
                            {/* Close Button */}
                            {/* <button
                                onClick={() => setShowOptionModal(false)}
                                className="absolute top-2 right-2 text-black text-xl font-bold hover:text-red-500"
                            >
                                &times;
                            </button>
                            <h2 className="text-xl text-black mb-4 text-center">Choose Payment Method</h2>
                            <button onClick={createOrder} className="mr-4 px-4 py-2 bg-[#2C594C] text-white rounded">Terminal</button>
                            <button onClick={handleUrlOrder} className="px-4 py-2 bg-[#4f598c] text-white rounded">Checkout URL</button>
                        </div>
                    </div>
                )} */}
                      <PaymentOptionModal
                        isOpen={showOptionModal}
                        onClose={() => setShowOptionModal(false)}
                        onTerminalClick={createOrder}
                        onUrlClick={handleUrlOrder}
                    />
                {showUrlModal && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                        <div className="relative bg-white p-6 rounded-lg max-w-md w-full">
                            {/* Close Button */}
                            <button
                                onClick={() => setShowUrlModal(false)}
                                className="absolute top-2 right-2 text-black text-xl font-bold hover:text-red-500"
                            >
                                &times;
                            </button>
                            <h2 className="text-xl font-semibold text-center text-black mb-4">Share Checkout Link</h2>
                            <input
                                type="text"
                                className="w-full p-2 border rounded mb-4 text-black"
                                readOnly
                                value={checkoutUrl}
                                onFocus={e => e.target.select()}
                                />
                            <div className="flex justify-around space-x-2">
                                <button
                                    onClick={() => {
                                        navigator.clipboard.writeText(checkoutUrl);
                                        notifySuccess("Copied!");
                                        setCopied(true);
                                        setTimeout(() => setCopied(false), 2000);
                                    }}
                                    className={`px-4 py-2 rounded transition ${copied ? "bg-[#4f598c] text-white" : "bg-blue-500 hover:bg-blue-600"
                                        }`}
                                >
                                    {copied ? "Copied!" : "Copy"}
                                </button>
                                <a
                                    href={checkoutUrl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
                                >
                                    Pay Now
                                </a>
                            </div>
                        </div>
                    </div>
                )}

            </footer>

            {stripeModal && (
                <StripeModal
                    eModal
                    orderId={orderId}
                    cart={cartItems}
                    cartTotal={cartTotal}
                    stripeCustomer={customerId}
                />
            )}
        </>
    );
}

export default Footer;
